import React, { ChangeEvent, FormEvent, useRef } from "react"
import { Grid } from '@mui/material';
import { AlertInfoFileType } from "../common/AlertInfoFileType";

type PropsType = {
  systemInfo: string
  setHtml: (html: string) => void
  addFileToSystemInfo: (event: ChangeEvent<HTMLInputElement>) => void
}

export const ContentEditableInfo = (props: PropsType) => {

  const state = useRef({ value: props.systemInfo, prevValue: 'x' })
  if (state.current.prevValue !== props.systemInfo) {
    state.current.value = props.systemInfo
  }

  const handleInput = (event: FormEvent<HTMLDivElement>) => {
    const htmlNew = event.currentTarget.innerHTML
    state.current.prevValue = htmlNew
    props.setHtml(htmlNew)
  }

  return (
    <>
      <Grid item xs={12}   id='divInSystemInfo' >
        <div 
      
        contentEditable='true'
          data-placeholder='Add a description .... '
          className='area'
          onInput={handleInput}
          dangerouslySetInnerHTML={{ __html: state.current.value }}></div>
      </Grid>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {/* <AlertInfoFileType addFile={props.addFileToSystemInfo} text="Valid file types are:  jpg, jpeg, png, bmp, gif." /> */}
      </Grid>
    </>
  )
}
